module.exports = __webpack_public_path__ + "static/media/Warning-Filled-yellow.2ee8bf71.svg";